import React from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import styles from '../../../../../../layout/layoutHeader/components/styles';
import StyledToolTip from '../../../../../common/StyledToolTip';
import StartTripIcon from '../../../../../../layout/icons/StartTripIcon';
import { compose } from 'recompose';

const StartTrip = ({ classes, theme, enable, eventHub }) => {
  const onShowStartTrip = () => {
    if (enable) {
       eventHub.emit('onShowStartTrip');
    }
  };

  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${
        enable ? classes.enabledDangerIcon : classes.disableIcon
      }`}
      onClick={onShowStartTrip}>
      <StyledToolTip title="Start Trip">
        <div className="end-trip-icon-wrapper">
          <StartTripIcon color={enable ? theme.HeaderSelectedText : theme.iconColor} />
        </div>
      </StyledToolTip>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(React.memo(StartTrip));